import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@/hooks/useAnalytics';
import { LanguageSelector } from '@/components/common/LanguageSelector';
import { LandingButton } from './LandingButton';

export const LandingNav = React.memo(() => {
  const { t } = useTranslation();
  const { track } = useAnalytics();

  return (
    <header className="fixed top-0 w-full z-50 border-b border-gray-200/70 bg-white/80 backdrop-blur-md">
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="ow-logo" aria-label="OS Works">
            <span className="ow-logo__mark">
              <img src="/bee.png" alt="" />
            </span>
            <span className="ow-logo__wm">
              <span className="os">os</span>works
            </span>
          </Link>
          <div className="flex items-center gap-3">
            <LanguageSelector variant="compact" />
            <Link to="/empresas">
              <LandingButton type="button" variant="ghost" size="sm">
                {t('marketplace.findServices')}
              </LandingButton>
            </Link>
            <Link to="/auth">
              <LandingButton type="button" variant="ghost" size="sm">
                {t('landing.nav.login')}
              </LandingButton>
            </Link>
            <Link
              to="/auth?tab=signup"
              onClick={() => track('landing_cta_clicked', { location: 'nav' })}
            >
              <LandingButton type="button" variant="default" size="sm">
                {t('landing.nav.startFree')}
              </LandingButton>
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
});
LandingNav.displayName = 'LandingNav';
